import { EDCOMP_TITLE, EDCOMP_EQUATION, EDCOMP_PARAG, EDCOMP_FIGURE, EDCOMP_INT_FIGURE, EDCOMP_MULTIFIGURE, EDCOMP_EQN_MULTILINE, EDCOMP_PROBLEM_SET, EDCOMP_NOTEBOOK, EDCOMP_INT_FIGURE_DISCRETE, EDCOMP_FEEDBACK } from "../../constants/frameConstants";
import { useEffect, useState, useRef } from 'react';


// Find where this comment is in the structure
export function find_comment_indices(content, comment_id)
{
    console.log("find_comment_indices")
    let start_state = 0
    let position_info = {subsection_count:-1, frame_count:-1, comment_count:-1, start_state:-1, n_state:-1}
    for (let c_subsection  = 0; c_subsection< content.subsections?.length; c_subsection++)
    {
        for (let c_frame = 0; c_frame < content.subsections[c_subsection].frames?.length; c_frame++)
        {
            start_state+=content.subsections[c_subsection].frames[c_frame].n_state
            for (let c_comment = 0; c_comment< content.subsections[c_subsection].frames[c_frame].comments?.length; c_comment++){
                if(comment_id === content.subsections[c_subsection].frames[c_frame].comments[c_comment]._id)
                {
                    position_info.n_state = content.subsections[c_subsection].frames[c_frame].n_state ; 
                    position_info.start_state = start_state - position_info.n_state ;
                    position_info.subsection_count = c_subsection ; 
                    position_info.frame_count = c_frame ; 
                    position_info.comment_count = c_comment ; 
                    position_info.depth = 0 ; 
                    position_info.child_indices = []
                    return position_info 
                }
                for (let c_child1 = 0; c_child1 < content.subsections[c_subsection].frames[c_frame].comments[c_comment].children?.length; c_child1++)
                {
                    if(comment_id === content.subsections[c_subsection].frames[c_frame].comments[c_comment].children[c_child1]._id)
                    {
                        position_info.n_state = content.subsections[c_subsection].frames[c_frame].n_state ; 
                        position_info.start_state = start_state - position_info.n_state ;
                        position_info.subsection_count = c_subsection ; 
                        position_info.frame_count = c_frame ; 
                        position_info.comment_count = c_comment ; 
                        position_info.depth = 1 ; 
                        position_info.child_indices = [c_child1]
                        return position_info 
                    }
                    for (let c_child2 = 0; c_child2 < content.subsections[c_subsection].frames[c_frame].comments[c_comment].children[c_child1].children?.length;c_child2++)
                    {
                        if(comment_id === content.subsections[c_subsection].frames[c_frame].comments[c_comment].children[c_child1].children[c_child2]._id)
                        {
                            position_info.n_state = content.subsections[c_subsection].frames[c_frame].n_state ; 
                            position_info.start_state = start_state - position_info.n_state ;
                            position_info.subsection_count = c_subsection ; 
                            position_info.frame_count = c_frame ; 
                            position_info.comment_count = c_comment ; 
                            position_info.depth = 2 ; 
                            position_info.child_indices = [c_child1,c_child2]
                            return position_info 
                        }
                        for (let c_child3 = 0; c_child3 < content.subsections[c_subsection].frames[c_frame].comments[c_comment].children[c_child1].children[c_child2].children?.length;c_child3++)
                        {
                            if(comment_id === content.subsections[c_subsection].frames[c_frame].comments[c_comment].children[c_child1].children[c_child2].children[c_child3]._id)
                            {
                                position_info.n_state = content.subsections[c_subsection].frames[c_frame].n_state ; 
                                position_info.start_state = start_state - position_info.n_state ;
                                position_info.subsection_count = c_subsection ; 
                                position_info.frame_count = c_frame ; 
                                position_info.comment_count = c_comment ; 
                                position_info.depth = 3 ; 
                                position_info.child_indices = [c_child1,c_child2,c_child3]
                                return position_info 
                            }
                            for (let c_child4 = 0; c_child4 < content.subsections[c_subsection].frames[c_frame].comments[c_comment].children[c_child1].children[c_child2].children[c_child3].children?.length;c_child4++)
                            {
                                if(comment_id === content.subsections[c_subsection].frames[c_frame].comments[c_comment].children[c_child1].children[c_child2].children[c_child3].children[c_child4]._id)
                                {
                                    position_info.n_state = content.subsections[c_subsection].frames[c_frame].n_state ; 
                                    position_info.start_state = start_state - position_info.n_state ;
                                    position_info.subsection_count = c_subsection ; 
                                    position_info.frame_count = c_frame ; 
                                    position_info.comment_count = c_comment ; 
                                    position_info.depth = 4 ; 
                                    position_info.child_indices = [c_child1,c_child2, c_child3, c_child4]
                                    return position_info 
                                }
                            }
                        }
                    }
                }
            }
        }

    }
    console.log("Didn't find id")
    return position_info                  
}



// Find indices of current frame.
export function find_active_position(content, active_state)
{
    console.log("find_active_position")
    let start_state = 0
    let position_info = {subsection_count:-1, frame_count:-1}
    for (let c_subsection  = 0; c_subsection< content.subsections?.length; c_subsection++)
    {
        for (let c_frame = 0; c_frame < content.subsections[c_subsection].frames?.length; c_frame++)
        {
            if(active_state >= start_state && active_state < start_state+content.subsections[c_subsection].frames[c_frame].n_state)
            {
                position_info.subsection_count = c_subsection
                position_info.frame_count = c_frame
                return position_info 
            }
            start_state+=content.subsections[c_subsection].frames[c_frame].n_state
        }
    }
    return position_info 
}

export function update_frame_states(content)
{
    let contentCopy = structuredClone(content)
    for (let c_section = 0; c_section<contentCopy.length; c_section++)
    {
        let n_content_state = 0 ; 
        for (let c_subsection  = 0; c_subsection< contentCopy[c_section].subsections?.length; c_subsection++)
        {
            let n_subsection_state = 0;
            for (let c_frame = 0; c_frame < contentCopy[c_section].subsections[c_subsection].frames?.length; c_frame++)
            {
                let n_frame_state = 0;
                for (let c_frame_content = 0; c_frame_content < contentCopy[c_section].subsections[c_subsection].frames[c_frame].contents?.length; c_frame_content++)
                {
                    let max_state_in_content = 0
                    max_state_in_content =  Math.max(...contentCopy[c_section].subsections[c_subsection].frames[c_frame].contents[c_frame_content].active_state) 
                    n_frame_state = Math.max(max_state_in_content+1, n_frame_state)
                }

                n_subsection_state += n_frame_state
                contentCopy[c_section].subsections[c_subsection].frames[c_frame].n_state  = n_frame_state
            }
            contentCopy[c_section].subsections[c_subsection].n_state = n_subsection_state
            n_content_state += n_subsection_state
        }
        contentCopy[c_section]["n_state"] = n_content_state
    }
    return contentCopy

}

export function add_reference(text, labels, tags){
    if(text===undefined || text===""){
        return text
    }
    const match_array = [...text.matchAll(new RegExp("\\\\ref\\{([^\\}]+)\\}\\{([^\\}]*)\\}","gm"))]
    for (let c_match = 0; c_match < match_array.length; c_match++)
    {
        let index = labels.indexOf(match_array[c_match][1]);
        if(index >=-1){
            text= text.replace(new RegExp("\\\\ref\\{("+match_array[c_match][1]+")\\}\\{([^\\}]*)\\}","gm"), "\\ref{"+match_array[c_match][1]+"}{"+tags[index]+"}")
        }
    }
    return text;
}


export function update_tags_all(content)
{
    // Determines mapping from labels to tages
    let labels = []
    let tags = []

    let chapter_count = 0 
    let section_count = 0
    let subsection_count = 0
    let equation_count = 0
    let figure_count = 0

    for (let c_section = 0; c_section < content.length; c_section++)
    {
        // Run through all content once, adding in tags
        for (let c_subsection  = 0; c_subsection< content[c_section].subsections?.length; c_subsection++)
        {
            for (let c_frame = 0; c_frame < content[c_section].subsections[c_subsection].frames?.length; c_frame++)
            {
                for (let c_content = 0; c_content < content[c_section].subsections[c_subsection].frames[c_frame].contents?.length; c_content++)
                {
                    if(content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].type===EDCOMP_TITLE){
                        let level = content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.level
                        let title = content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].title
                        if(!title.includes("tag{")){
                            title = "\\tag{x}"+title
                        }
                        let number_text = ""
                        switch(level){
                            case "chapter":
                    
                                chapter_count = chapter_count+1
                                section_count = 0
                                subsection_count = 0
                                equation_count = 0
                                number_text = "\\tag{}"
                                break
                            case "section":
                                
                                section_count = section_count + 1 
                                subsection_count = 0
                                equation_count = 0
                                figure_count = 0 
                                number_text = "\\tag{"+section_count+"}"
                                break
                            case "subsection":
                                subsection_count = subsection_count + 1
                                equation_count = 0 
                                number_text = "\\tag{"+section_count+"."+subsection_count+"}"
                                break
                            default:
                                break
                        }
                        content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].title = title.replace(new RegExp("\\\\tag\\{[^\\}]*\\}","gm"),number_text)
                        if (content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data?.label!==""){
                            labels.push(content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data?.label)
                            tags.push(number_text.replace(new RegExp("\\\\tag\\{([^\\}]+)\\}","gm"),"$1"))
                        }
                    }
                    if(content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].type===EDCOMP_EQUATION  ||
                        content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].type === EDCOMP_EQN_MULTILINE){
                        let equation_text = content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.equation
                        if(equation_text.includes("tag{")){
                            equation_count++
                            let number_text = "\\tag{"+section_count +"."+subsection_count + "." + equation_count+"}"
                            content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.equation = equation_text.replace(new RegExp("\\\\tag\\{[^\\}]+?\\}","gm"),number_text)
                            labels.push(content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data?.label)
                            tags.push(number_text.replace(new RegExp("\\\\tag\\{([^\\}]+)\\}","gm"),"$1"))
                        }
                    }

                    if(content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].type===EDCOMP_FIGURE ||
                        content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].type=== EDCOMP_INT_FIGURE ||
                            content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].type=== EDCOMP_INT_FIGURE_DISCRETE ||
                                content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].type=== EDCOMP_MULTIFIGURE){
                        let caption_text = content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.text
                        if(caption_text.includes("tag{")){
                            figure_count++
                            let number_text = "\\tag{"+section_count + "." + figure_count+"}"
                            content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.text = caption_text.replace(new RegExp("\\\\tag\\{[^\\}]+?\\}","gm"),number_text)

                            labels.push(content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data?.label)
                            tags.push(number_text.replace(new RegExp("\\\\tag\\{([^\\}]+)\\}","gm"),"$1"))
                        }
                    }
                }
            }
        }
    }
    // Run through content a second time, updating labels in paragraphs
    for (let c_section = 0; c_section < content.length; c_section++)
    {
        for (let c_subsection  = 0; c_subsection< content[c_section].subsections?.length; c_subsection++)
        {
            for (let c_frame = 0; c_frame < content[c_section].subsections[c_subsection].frames?.length; c_frame++)
            {
                for (let c_content = 0; c_content < content[c_section].subsections[c_subsection].frames[c_frame].contents?.length; c_content++)
                {
                    let type = content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].type
                    if(type === EDCOMP_PARAG || type=== EDCOMP_FIGURE || type=== EDCOMP_INT_FIGURE || type === EDCOMP_INT_FIGURE_DISCRETE || type === EDCOMP_NOTEBOOK){
                        let paragraph_text = content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.text
                        paragraph_text = add_reference(paragraph_text, labels, tags) ; 
                        content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.text = paragraph_text 
                    }
                    if (type===EDCOMP_FEEDBACK){
                        let title = content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].title
                        title = add_reference(title, labels, tags) ; 
                        content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].title = title
                    }
                    if(type === EDCOMP_PROBLEM_SET){
                        for(let c_problem = 0; c_problem < content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.problems?.length; c_problem++)
                        {
                            if(content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.problems[c_problem].hasOwnProperty('question')){
                                let question_text = content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.problems[c_problem].question
                                question_text = add_reference(question_text, labels, tags) ; 
                                content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.problems[c_problem].question = question_text
                            }

                            if(content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.problems[c_problem].hasOwnProperty('question2')){
                                let question_text2 = content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.problems[c_problem].question2
                                question_text2 = add_reference(question_text2, labels, tags) ; 
                                content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.problems[c_problem].question2 = question_text2
                            }

                            if(content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.problems[c_problem].hasOwnProperty('answer')){
                                let answer_text = content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.problems[c_problem].answer
                                answer_text = add_reference(answer_text, labels, tags) ; 
                                content[c_section].subsections[c_subsection].frames[c_frame].contents[c_content].data.problems[c_problem].answer = answer_text
                            }
                        }
                    }
                }
            }
        }
    }
    return content
}

export const isVisibleInViewport = (element) => {
    const rect = element.getBoundingClientRect()
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
}


export function useOnScreen(ref) {
  const [isOnScreen, setIsOnScreen] = useState(false);
  const observerRef = useRef(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(([entry]) =>
      setIsOnScreen(entry.isIntersecting), {rootMargin: "0px 0px -50% 0px"}
    );
  }, []);

  useEffect(() => {
    observerRef.current.observe(ref.current);

    return () => {
      observerRef.current.disconnect();
    };
  }, [ref]);

  return isOnScreen;
}

// Style for main column width that puts square/circle/triangle in the correct place
export const computeWidgetStyleMain=(windowWidth, tocVisible=true)=>{
    // Compute widths for every configuration
    var widthStyleMain ; 

    if(tocVisible){
        // Max size
        if(windowWidth >=1710)
        {
            widthStyleMain={width:'794px'}
        }
        else{
            if(windowWidth <=1023){
                widthStyleMain = {width: 'calc(100vw - 64px)', maxWidth:'794px'}
            }
            else{
                // Left panel closed
                if(windowWidth<=1499){
                    widthStyleMain={width: '61.3%', maxWidth: '794px', minWidth: '612px'}
                }
                // Left panel open but not yet max
                else{
                    widthStyleMain={width: '47.1%', maxWidth: '794px'}
                }
            }
        }
    }
    else{
        // Max size
        if(windowWidth >=1710)
        {
            widthStyleMain={width:'794px'}
        }
        else{
            if(windowWidth <=1023){
                widthStyleMain = {width: 'calc(100vw - 64px)', maxWidth:'794px'}
            }
            else{
                // Left panel closed
                if(windowWidth<=1499){
                    widthStyleMain={width: '61.3%', maxWidth: '794px', minWidth: '612px'}
                }
                // Left panel open but not yet max
                else{
                    widthStyleMain={width: '54.6%', maxWidth: '794px'}
                }
            }
        }
    }
    return widthStyleMain ; 
}

// Style for the widgets that puts the comments in the right place
export const computeWidgetStyleRight=(windowWidth)=>{
    var widthStyleRight ; 
    if(windowWidth >= 1770)
    {
        widthStyleRight={width:'464px'}
    }   
    else{
        if(windowWidth< 500){
            widthStyleRight={width:'80vw', marginLeft:'-85vw'}
        }
        else{
            if(windowWidth<=1023){
                widthStyleRight={width:'450px', marginLeft:'-485px'}
            }
            else{
            if(windowWidth<=1499)
                {
                    widthStyleRight={width:'35.3%', maxWidth:'460px'}
                }
                else{
                    widthStyleRight={width:'27.1%'}
                }
            }   
        }
    }
    return widthStyleRight ; 
}

// Style for the widgets that puts the comments in the right place
// export const computeWidgetStyleRightBubble=(windowWidth)=>{
//     var widthStyleRight ; 
//     if(windowWidth >= 1770)
//     {
//         widthStyleRight={width:'454px'}
//     }   
//     else{
//         if(windowWidth< 500){
//             widthStyleRight={width:'80vw', marginLeft:'-85vw'}
//         }
//         else{
//             if(windowWidth<=1023){
//                 widthStyleRight={width:'440px', marginLeft:'-485px'}
//             }
//             else{
//             if(windowWidth<=1499)
//                 {
//                     widthStyleRight={width:'35.3%', maxWidth:'460px'}
//                 }
//                 else{
//                     widthStyleRight={width:'27.1%'}
//                 }
//             }   
//         }
//     }
//     return widthStyleRight ; 
// }





// Style for the widgets that puts the comments in the right place
export const computeWidgetStyleRightEquation=(windowWidth)=>{
    var widthStyleRight ; 
    if(windowWidth >= 1770)
    {
        widthStyleRight={width:'457px'}
    }
    else{
        if(windowWidth<=1023){
            widthStyleRight={ marginLeft:'calc(100% - 38px)' ,zIndex:'100'}
        }
        else{
            if(windowWidth<=1499)
            {
                widthStyleRight={width:'35.9%', maxWidth:'482px'}
            }
            else{
                widthStyleRight={width:'36.3%', maxWidth:'482px'}
            }
        }
    }
    return widthStyleRight ; 
}


export const copyEquation=(equation_text)=>{
    // Remove delimiters
    let equationString  = equation_text.replaceAll("$$","")
    equationString= equationString.replace(new RegExp("\\\\tag\\{[^\\}]+\\}","gm"), "")

    // Remove full stop at end
    if (equationString && equationString.endsWith('.')) {
        equationString = equationString.slice(0, -1);
    }
    // Remove comma at end
    if (equationString && equationString.endsWith(',')) {
        equationString = equationString.slice(0, -1);
    }
    navigator.clipboard.writeText(equationString)
}


export function isFirefox() {
    return typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);
  }
  


// Returns the percentage of the possible title stored in progress content seen
export const calcPercentRead = (content, progressContentSeen)=> {
    let n_content = 0 ;
    let n_content_seen = 0 
    for (let c_section = 0; c_section < content?.length; c_section++){
        if(content[c_section].hasOwnProperty('title')){
            content[c_section].subsections.forEach((subsection)=>{
                subsection.frames.forEach((frame)=>{
                    frame.contents.forEach((component)=>{
                        if(component.type=== EDCOMP_TITLE){
                            n_content++ ;
                            if(progressContentSeen.includes(String(component._id))){
                                n_content_seen++ ; 
                            }
                        }
                    })
                })
            })
        }
    }
    return 100 * n_content_seen/n_content
}

export const calcSizeInMb=(content)=> {
    // Returns the size of an object in MB
    // Calculate the BSON size of the object
    // Note: JSON stringify is a good proxy for BSON size
    const jsonString = JSON.stringify(content);
    const sizeInBytes = new TextEncoder().encode(jsonString).length;
    const sizeInMb = sizeInBytes / (1024 * 1024)
    return sizeInMb ; 
}
